import styled from 'styled-components';
import { Theme } from '@/theme';

export const Title = styled.h3`
  font-weight: 700;
  font-size: 34px;
  line-height: 110%;
  text-align: center;
  letter-spacing: 0.01em;
  text-shadow: 1px 1px 0px rgba(0, 0, 0, 0.6);
  color: ${Theme.color.orange};
  margin-bottom: 16px;
`;

export const PickerStyled = styled.div`
  .react-colorful {
    width: 100% !important;
    height: auto !important;
    margin-bottom: 26px;
  }

  .react-colorful__saturation {
    border-radius: 16px;
    margin-bottom: 16px;
    aspect-ratio: 280 / 200;
  }

  .react-colorful__last-control {
    border-radius: 16px;
  }

  .react-colorful__pointer {
    border: 3px solid ${Theme.color.white};
    border-radius: 32px;
    width: 24px;
    height: 24px;
  }
  .react-colorful__hue {
    height: 32px;
  }
`;
